module.exports = __webpack_public_path__ + "img/zeigling9.1000ed6f.jpg";